import React from 'react';
import { fromUtcToDeviceTimeZoneForMessages } from '../../utils/dateFormatter';
import { isObjectNotEmpty } from '../../utils/objectUtils';
import { FaArrowCircleRight } from 'react-icons/fa';
import { useLocation, useNavigate, useSearchParams } from 'react-router';
import { isStringNotEmpty } from '../../utils/objectUtils';
import { toDisplayText } from '../../utils/renderValue';
import NotificationIcon from './NotificationIcon';

const NewNotificationToast = ({ notification }) => {
    //#region useSearchParams

    const [searchParams, setSearchParams] = useSearchParams();

    //#endregion
    //#region useNavigate

    const navigate = useNavigate();

    //#endregion
    //#region useLocation

    const location = useLocation();

    //#endregion
    //#region goTos

    const goTo = (path) => {
        navigate({ pathname: path, search: searchParams.toString() }, { state: { from: location }, replace: false });
    };

    //#endregion

    const onNewMessageClick = () => {
        if (isObjectNotEmpty(notification?.cta) && isStringNotEmpty(notification?.cta?.url)) {
            goTo(notification?.cta?.url);
        }
    };

    return (
        <a onClick={(e) => { e.preventDefault(); onNewMessageClick(); }}>
            <div className="d-flex flex-row">
                <NotificationIcon severity={notification?.severity} type={notification?.type} />
                <div className="d-inline-flex flex-column me-2">
                    <h5 className="fw-bold mb-0">{notification?.subject}</h5>
                    <div className="fs-5 mb-0">{toDisplayText(notification?.body)}</div>

                    {notification?.cta?.label ? <u>{notification?.cta?.label}</u> : null}

                    <div className="fs-6 mb-0 text-muted">
                        <span>
                            {fromUtcToDeviceTimeZoneForMessages(notification?.createdAt)}
                        </span>
                    </div>
                </div>
                <div className="text-end ms-auto flex-shrink-0">
                    <FaArrowCircleRight size={24} fill="var(--geeks-ready-black)" />
                </div>
            </div>
        </a>
    );
};

export default NewNotificationToast;